import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../../shared/media-query';
import dayjs from 'dayjs';
import DatePicker from '../../../app/components/date-picker';
import Pill from './shared/pill';
import TextLinks from './shared/daily-text-links';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            date: props.date || dayjs().format('YYYY-MM-DD'),
            base_url: props.base_url,
            vip: props.base_url.match(/vip/),
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.logged_in != this.props.logged_in) {
            if (nextProps.logged_in == false && this.state.vip) { //user logs out on VIP page
                document.location.href = this.state.base_url.replace(/\/vip/, '');
                return false;
            } else if (
                nextProps.logged_in == true
                &&
                nextProps.user.subscriptions
                &&
                nextProps.user.subscriptions.vip
                &&
                !this.state.vip
                &&
                !this.props.weekly
            ) { //user logs in on non-VIP page
                document.location.href = `/vip${this.state.base_url}`;
                return false;
            } // reload page to get "you" card LI or reset back to "everyone" card LO

            if (this.props.weekly) {
                // on lo/li redirect to base page, same as horoscope behavior
                document.location.href = this.state.base_url;
                return true;
            }

            document.location.reload();
        }

        if (nextState.date != this.state.date) {
            return true;
        }

        if (nextProps.tcod != this.props.tcod) {
            return true;
        }

        if (nextProps.route != this.props.route) {
            return true;
        }

        return false;
    }

    /* eslint-disable complexity */
    render({ route, tcod, date, base_url, logged_in, weekly, sign, trackPromo, trackEvent }, { vip }) {
        let card = tcod.everyone;
        let display_date = dayjs(date).format('M.D.YY');

        if (route != 'everyone' && tcod.you) {
            card = tcod.you;
        }

        let forWho = route == 'everyone' || !logged_in ? 'Everyone' : 'You';

        if (weekly) {
            forWho = sign == 'general' ? 'Everyone' : 'You';
            display_date = 'Week of ' + dayjs(date).format('dddd, MMMM D') + ':';
        }

        if (vip) {
            const img_url = `https://gfx.tarot.com/images/site/decks/${card.deck.slug}/full_size/${card.card_id}.jpg`;

            if (MQ.isMobile()) {
                if (weekly) {
                    return (
                        <daily-tarot-card>
                            {this.renderTopWeekly()}
                            {this.renderHeader(vip, route, trackPromo)}
                            <div className='daily-tarot-card-mobile'>
                                <p className='has-text-center'>
                                    <a href={`/tarot/cards/${card.card.canonical_rank}/${card.deck.slug}`}>
                                        <img src={img_url} alt={card.card.name} height='300' width='225' />
                                    </a>
                                </p>
                                <small>
                                    <a href={`/tarot/decks/${card.deck.slug}`}>
                                        {card.deck.name}
                                    </a> deck {card.deck.deck_vendor_copyright}
                                </small>
                                <br />
                                {card.interp_body.map((p, key) => {
                                    if (key == 0) {
                                        return (
                                            <p>
                                                <b>{display_date} {card.card.name}: </b>
                                                {p}
                                            </p>
                                        );
                                    }

                                    return (<p>{p}</p>);
                                })}
                            </div>
                        </daily-tarot-card>
                    );
                }

                return (
                    <daily-tarot-card date={date}>
                        <row className='is-aligned-center'>
                            <column className='is-1'>
                                <DatePicker
                                    mindate={dayjs().subtract(90, 'day').format('YY-MM-DD')}
                                    maxdate={dayjs().add(2, 'day').format('YY-MM-DD')}
                                    autosubmit='true'
                                    date={dayjs(date).format('YYYY-MM-DD')}
                                    page='tarot-card'
                                    url={`${base_url || '/daily-tarot-card'}/:date`}
                                />
                            </column>
                            <column className='is-11 has-padding-20-left-mobile'>
                                <div className='daily-links'>
                                    <a href='#everyone' className={route == 'everyone' ? 'selected' : ''}>
                                        FOR EVERYONE
                                    </a>
                                    <a href='#you' className={route != 'everyone' ? 'selected' : ''}>
                                        FOR YOU
                                    </a>
                                </div>
                            </column>
                        </row>
                        <h1>Tarot Card of the Day</h1>
                        <div className='daily-tarot-card-mobile'>
                            <p className='has-text-center'>
                                <a href={`/tarot/cards/${card.card.canonical_rank}/${card.deck.slug}`}>
                                    <img src={img_url} alt={card.card.name} height='300' width='225' />
                                </a>
                            </p>
                            <small>
                                <a href={`/tarot/decks/${card.deck.slug}`}>
                                    {card.deck.name}
                                </a> deck {card.deck.deck_vendor_copyright}
                            </small>
                            <br />
                            {card.interp_body.map((p, key) => {
                                if (key == 0) {
                                    return (
                                        <p>
                                            <b>{display_date} {card.card.name}: </b>
                                            {p}
                                        </p>
                                    );
                                }

                                return (<p>{p}</p>);
                            })}
                        </div>
                    </daily-tarot-card>
                );
            }

            return (
                <daily-tarot-card date={date}>
                    <div className='daily-tarot-card'>
                        <a href={`/tarot/cards/${card.card.canonical_rank}/${card.deck.slug}`}>
                            <img src={img_url} height='342' alt={card.card.name} />
                        </a>
                        <small>
                            <a href={`/tarot/decks/${card.deck.slug}`}>{card.deck.name}</a> deck
                            <br />
                            {card.deck.deck_vendor_copyright}
                        </small>
                    </div>
                    {weekly ? this.renderTopWeekly() : this.renderTopDaily()}
                    {this.renderHeader(vip, route)}
                    <br />
                    {card.interp_body.map((p, key) => {
                        if (key == 0) {
                            return (
                                <p className='has-margin-10-top'>
                                    <b>{display_date} {card.card.name}: </b>
                                    {p}
                                </p>
                            );
                        }

                        return (<p>{p}</p>);
                    })}
                </daily-tarot-card>
            );
        } else if (tcod && (tcod.everyone || tcod.you)) {
            return (
                <daily-tarot-card date={date}>
                    {weekly ? this.renderTopWeekly() : this.renderTopDaily()}
                    <row className='is-wrap'>
                        <column className='is-4 is-5-mobile has-padding-20-right'>
                            {this.renderImage(card, forWho)}
                        </column>
                        <column className='is-8 is-7-mobile'>
                            {this.renderHeader()}
                            <h3>
                                For {forWho}:&nbsp;
                                <a
                                    href={`/tarot/cards/${card.card.canonical_rank}/${card.deck.slug}`}
                                    onClick={() => trackEvent([
                                        `${weekly ? 'Weekly' : 'Daily'} Tarot`,
                                        'Click',
                                        `For ${forWho}`,
                                        `${weekly ? 'Weekly' : 'Daily'}Tarot:For${forWho}`,
                                    ])}
                                >
                                    {card.card.name}
                                </a>
                            </h3>
                            <p>
                                <a
                                    href={`/tarot/decks/${card.deck.slug}`}
                                    onClick={() => this.handleClick(card.deck.name)}
                                >
                                    {card.deck.name.replace(/ Tarot$/, '')} Tarot Deck
                                </a>
                            </p>
                            {this.renderSubLinks(card, false)}
                        </column>
                        <column className='is-12 is-visible-mobile has-padding-30-top-mobile'>
                            {this.renderSubLinks(card, true)}
                        </column>
                    </row>

                    {card.interp_body.map((p, key) => {
                        if (key == 0) {
                            return (
                                <p className='has-margin-30-top'>
                                    <b>{display_date} {card.card.name}: </b>
                                    {p}
                                </p>
                            );
                        }

                        return (<p>{p}</p>);
                    })}
                </daily-tarot-card>
            );
        }

        return (<daily-tarot-card />);
    }
    /* eslint-enable complexity */

    renderHeader = (vip, route, trackPromo) => {
        if (this.props.weekly) {
            if (this.props.sign != 'general') {
                const sign = this.props.sign.charAt(0).toUpperCase() + this.props.sign.slice(1);
                return (<h1>{sign} Weekly Tarot Horoscope</h1>);
            }

            return (<h1>Weekly Tarot Horoscope</h1>);
        }

        if (vip) {
            return [
                <h1>Tarot Card of<br />the Day</h1>,
                <div className='daily-links'>
                    <a href={route == 'everyone' ? '#you' : '#everyone'}>
                        {route == 'everyone' ? 'Your' : "Everyone's"} Tarot Card
                    </a>
                    <a
                        href='/readings-reports/tarot-readings/daily-reflection'
                        onClick={() => trackPromo(['TCOD', 'DRT'])}
                    >
                        Get Your Daily Tarot Reading
                    </a>
                </div>,
            ];
        }

        return (<h1>Tarot Card of<br />the Day</h1>);
    }

    /* eslint-disable complexity */
    renderSubLinks = (tcod, for_mobile) => {
        const daily_weekly_label = this.props.weekly ? 'Tarot Card of the Day' : 'Weekly Tarot Horoscopes';
        const daily_weekly_url = this.props.weekly ? '/daily-tarot-card' : '/tarot/weekly-tarot-card-reading';
        const deck_label = 'View All Cards in This Deck';

        const reading_url = this.props.logged_in
            ? '/readings-reports/tarot-readings/celtic-cross'
            : '/readings-reports/tarot-readings/free';

        const reading_label = this.props.logged_in
            ? 'Get a Reading in this Deck'
            : 'Your FREE Reading With This Deck';

        let reveal_label = this.props.route == 'everyone' || !this.props.logged_in
            ? 'Reveal YOUR Daily Tarot Card'
            : 'General Tarot Card of the Day';

        let reveal_link = '#everyone';
        if (this.props.route == 'everyone' || !this.props.logged_in) {
            reveal_link = this.props.logged_in ? '#you' : '#login-signup';
        }

        if (this.props.weekly) {
            reveal_label = this.props.logged_in
                ? 'Get a Daily Tarot Reading'
                : 'Reveal YOUR Weekly Tarot Horoscope';

            reveal_link = this.props.logged_in
                ? '/readings-reports/tarot-readings/daily-reflection'
                : '#login-signup';
        }

        if (for_mobile && MQ.isMobile()) {
            return (
                <div className='tcod-pills'>
                    <row>
                        <column className='is-12 is-flex'>
                            <Pill
                                label={reading_label}
                                link={`${reading_url}?deck=${tcod.deck.slug}`}
                                handleClick={() => this.handleClick(reading_label)}
                            />
                            <Pill
                                label={deck_label}
                                link={`/tarot/decks/${tcod.deck.slug}`}
                                handleClick={() => this.handleClick(deck_label)}
                            />
                        </column>
                    </row>
                    <row className='has-margin-10-bottom'>
                        <column className='is-12 is-flex'>
                            <Pill
                                label={daily_weekly_label}
                                link={daily_weekly_url}
                                handleClick={() => this.handleClick(daily_weekly_label)}
                            />
                            <Pill
                                label={reveal_label}
                                link={reveal_link}
                                handleClick={() => this.handleClick(reveal_label)}
                            />
                        </column>
                    </row>
                </div>
            );
        } else if (!for_mobile && !MQ.isMobile()) {
            return (
                <div className='tcod-pills'>
                    <Pill
                        label={reading_label}
                        link={`${reading_url}?deck=${tcod.deck.slug}`}
                        handleClick={() => this.handleClick(reading_label)}
                    />
                    <Pill
                        label={deck_label}
                        link={`/tarot/decks/${tcod.deck.slug}`}
                        handleClick={() => this.handleClick(deck_label)}
                    />
                    <Pill
                        label={daily_weekly_label}
                        link={daily_weekly_url}
                        handleClick={() => this.handleClick(daily_weekly_label)}
                    />
                    <Pill
                        label={reveal_label}
                        link={reveal_link}
                        handleClick={() => this.handleClick(reveal_label)}
                    />
                </div>
            );
        }

        return null;
    }
    /* eslint-enable complexity */

    renderImage = (tcod, forWho) => {
        const img_url = `https://gfx.tarot.com/images/site/decks/${tcod.deck.slug}/full_size/${tcod.card_id}.jpg`;
        const img_size = MQ.isMobile() ? '300' : '342';

        return [
            <a
                href={`/tarot/cards/${tcod.card.canonical_rank}/${tcod.deck.slug}`}
                onClick={() => this.props.trackEvent([
                    `${this.props.weekly ? 'Weekly' : 'Daily'} Tarot`,
                    'Click',
                    `For ${forWho}`,
                    `${this.props.weekly ? 'Weekly' : 'Daily'}Tarot:For${forWho}`,
                ])}
            >
                <img alt={tcod.card.name} src={img_url} height={img_size} width='auto' />
            </a>,
            <small>
                <a href={`/tarot/decks/${tcod.deck.slug}`} onClick={() => this.handleClick(tcod.deck.code)}>
                    {tcod.deck.name}
                </a> deck {tcod.deck.deck_vendor_copyright}
            </small>,
        ];
    }

    renderTopDaily = () => {
        const url = this.state.base_url || '/daily-tarot-card';
        const date = dayjs(this.props.date).format('YYYY-MM-DD');

        return (
            <row className='is-aligned-center has-margin-30-bottom'>
                <column className='is-1'>
                    <DatePicker
                        mindate={dayjs().subtract(90, 'day').format('YYYY-MM-DD')}
                        maxdate={dayjs().add(2, 'day').format('YYYY-MM-DD')}
                        autosubmit='true'
                        date={date}
                        page='tarot-card'
                        url={`${url}/:date`}
                    />
                </column>
                <column className='is-11'>
                    <TextLinks date={date} base_url={url} />
                </column>
            </row>
        );
    }

    renderTopWeekly = () => {
        const last_week = dayjs().day(1).subtract(1, 'week').format('YYYY-MM-DD');
        const this_week = dayjs().day(1).format('YYYY-MM-DD');
        const next_week = dayjs().day(1).add(1, 'week').format('YYYY-MM-DD');
        const url = this.state.base_url || '/tarot/weekly-tarot-card-reading';

        return (
            <row className='is-aligned-center-mobile has-margin-20-bottom'>
                <column className='is-12'>
                    <div className='daily-links'>
                        <a
                            href={`${url}/${this.props.sign}/${last_week}`}
                            className={this.props.date == last_week ? 'selected' : ''}
                            onClick={() => this.props.trackEvent([
                                'Daily Nav',
                                'Click',
                                'Text - Last Week',
                                'Nav_Daily_Text:LastWeek',
                            ])}
                        >
                            Last Week
                        </a>
                        <a
                            href={`${url}/${this.props.sign}/${this_week}`}
                            className={this.props.date == this_week ? 'selected' : ''}
                            onClick={() => this.props.trackEvent([
                                'Daily Nav',
                                'Click',
                                'Text - This Week',
                                'Nav_Daily_Text:ThisWeek',
                            ])}
                        >
                            This Week
                        </a>
                        <a
                            href={`${url}/${this.props.sign}/${next_week}`}
                            className={this.props.date == next_week ? 'selected' : ''}
                            onClick={() => this.props.trackEvent([
                                'Daily Nav',
                                'Click',
                                'Text - Next Week',
                                'Nav_Daily_Text:NextWeek',
                            ])}
                        >
                            Next Week
                        </a>
                    </div>
                </column>
            </row>
        );
    }

    upperToCaps = (title) => {
        return title.split(' ').map(word => word.toUpperCase() == word
            ? word.charAt(0) + word.slice(1).toLowerCase()
            : word).join(' ');
    }

    handleClick = (title) => {
        this.props.trackEvent([
            'Daily Nav',
            'Click',
            `${this.props.weekly ? 'Weekly Tarot' : 'Tarot Card of the Day'}:${this.upperToCaps(title)}`,
            `${this.props.weekly ? 'Weekly' : 'Daily'}Tarot:${this.upperToCaps(title)}`,
        ]);
    }
}

const mapStateToProps = (state) => ({
    tcod: state.tcod,
    logged_in: state.user && state.user.logged_in,
    route: state.route,
    sign: state.sign || 'general',
    user: state.user,
    weekly: state.weekly,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({
        type: 'ga:event',
        payload: payload,
    }),
    trackPromo: (payload) => dispatch({
        type: 'promo-tracker:recordInternal',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
